/**
 * Why Frank Emiliano Video Functionality
 * Handles video play/pause, YouTube/Vimeo embedding
 */

(function() {
  'use strict';

  // Initialize video when DOM is ready
  function initWhyFrankVideo() {
    const videoContainer = document.querySelector('.why-frank-emiliano__video');
    if (!videoContainer) return;

    const playButton = videoContainer.querySelector('.why-frank-emiliano__play-button');
    const thumbnail = videoContainer.querySelector('.why-frank-emiliano__video-thumbnail');
    const iframeContainer = videoContainer.querySelector('.why-frank-emiliano__video-iframe');
    const videoElement = videoContainer.querySelector('.why-frank-emiliano__video-element');
    const videoType = videoContainer.dataset.videoType;
    const videoId = videoContainer.dataset.videoId;

    if (!playButton) return;

    // If Vimeo thumbnail placeholder exists, load it immediately (so user sees it before play)
    if (videoType === 'vimeo' && videoId) {
      loadVimeoThumbnail(videoId, videoContainer);
    }

    // Handle play button click
    playButton.addEventListener('click', function() {
      if (videoType === 'youtube' || videoType === 'vimeo') {
        // Show iframe and hide thumbnail
        if (thumbnail) {
          thumbnail.style.display = 'none';
        }
        if (iframeContainer) {
          iframeContainer.style.display = 'block';
        }
        if (videoContainer) {
          videoContainer.classList.add('why-frank-emiliano__video--playing');
        }
      } else if (videoElement) {
        // Handle direct video file
        if (videoElement.paused) {
          videoElement.play().catch(error => {
            console.error("Error attempting to play video:", error);
          });
          if (thumbnail) {
            thumbnail.style.display = 'none';
          }
          if (videoContainer) {
            videoContainer.classList.add('why-frank-emiliano__video--playing');
          }
        }
      }
    });

    // Handle direct video element play/pause
    if (videoElement) {
      videoElement.addEventListener('play', function() {
        if (thumbnail) {
          thumbnail.style.display = 'none';
        }
        if (videoContainer) {
          videoContainer.classList.add('why-frank-emiliano__video--playing');
        }
      });

      videoElement.addEventListener('pause', function() {
        if (thumbnail) {
          thumbnail.style.display = 'block';
        }
        if (videoContainer) {
          videoContainer.classList.remove('why-frank-emiliano__video--playing');
        }
      });

      // Click on video to pause
      videoElement.addEventListener('click', function() {
        if (!videoElement.paused) {
          videoElement.pause();
        }
      });
    }
  }

  // Load Vimeo thumbnail
  function loadVimeoThumbnail(videoId, container) {
    const thumbnailImg = container.querySelector('[data-vimeo-id]');
    if (!thumbnailImg || thumbnailImg.src) return; // Don't load if already loaded

    fetch(`https://vimeo.com/api/v2/video/${videoId}.json`)
      .then((response) => response.json())
      .then((data) => {
        if (data && data[0] && data[0].thumbnail_large) {
          thumbnailImg.src = data[0].thumbnail_large;
        }
      })
      .catch((error) => {
        console.error('Error loading Vimeo thumbnail:', error);
      });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhyFrankVideo);
  } else {
    initWhyFrankVideo();
  }

  // Re-initialize when sections are loaded dynamically (Shopify theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      if (event.detail.sectionId && document.querySelector('.why-frank-emiliano')) {
        initWhyFrankVideo();
      }
    });
  }
})();

